import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown"];
  static values = { url: String };

  async confirm({ params }) {
    await this.#dispatch(params.status, params.agent);
  }

  async override({ params }) {
    this.#hideDropdown();
    await this.#dispatch(params.status, null);
  }

  toggleOverride() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.toggle("hidden");
    }
  }

  #hideDropdown() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("hidden");
    }
  }

  async #dispatch(status, agentName) {
    const body = new URLSearchParams({ status });
    if (agentName) body.append("agent_name", agentName);
    body.append("_method", "patch");

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")
          ?.content,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body,
    });

    if (response.ok) {
      const html = await response.text();
      Turbo.renderStreamMessage(html);
    }
  }
}
